export default __webpack_public_path__ + "static/media/humblr-tablet.f8bf1e59.png";